/**
 * Derived credit-rate table for "how credits work" surfaces (Compare Plans
 * dialog, cost estimator modal).
 *
 * Derivation rule: private audiences bill at the Premium tier (`tier2`), so
 * every row below reads its rate off the tier2 slot of the shared-types
 * constants re-exported by `@/lib/billing/credit-rates`. No numeric literal
 * is ever inlined for a rate: this module exists specifically to kill the
 * class of stale-copy bug where a dialog's hardcoded rate drifts from the
 * real pricing constant after a re-price (the "0.4 vs 0.3" bug).
 */

import {
  AUDIENCE_CREATION_CREDITS,
  CREDITS_PER_RESPONDENT,
  QUICK_STUDY_CREDITS_PER_READ,
  CHAT_CREDITS_PER_MSG,
  ROOM_CREDITS_PER_MSG,
} from '@/lib/billing/credit-rates'

export interface CreditRateRow {
  action: string
  rate: number
  unit: string
}

export const PRIVATE_CREDIT_RATES: CreditRateRow[] = [
  { action: 'Audience creation', rate: AUDIENCE_CREATION_CREDITS, unit: 'per twin' },
  { action: 'Study', rate: CREDITS_PER_RESPONDENT.tier2, unit: 'per respondent' },
  { action: 'Quick study', rate: QUICK_STUDY_CREDITS_PER_READ.tier2, unit: 'per respondent per question' },
  { action: 'Chat', rate: CHAT_CREDITS_PER_MSG.tier2, unit: 'per message' },
  { action: 'Focus group', rate: ROOM_CREDITS_PER_MSG.tier2, unit: 'per message' },
]

export const MARKETPLACE_RATE_FOOTNOTE = 'Marketplace audience rates vary by premium level.'
